var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 136",
    width: 360,
    height: 136,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4 -783.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m256.3 825.8.7-7.5-6.2 4.3-3.4-6 6.8-3-6.8-3.2 3.4-6 6.2 4.3-.7-7.5h6.8l-.7 7.5 6.3-4.3 3.4 6-6.8 3.1 6.8 3.2-3.4 6-6.3-4.4.7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m256.3 825.8.7-7.5-6.2 4.3-3.4-6 6.8-3-6.8-3.2 3.4-6 6.2 4.3-.7-7.5h6.8l-.7 7.5 6.3-4.3 3.4 6-6.8 3.1 6.8 3.2-3.4 6-6.3-4.4.7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55 880.2.6-7.5-6.2 4.3-3.4-6 6.8-3-6.8-3.2 3.4-6 6.2 4.4-.7-7.5h6.9l-.7 7.5 6.2-4.4 3.4 6-6.8 3.1 6.8 3.2-3.4 6-6.2-4.4.7 7.5h-6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m306.3 850.3.7-7.5-6.2 4.4-3.5-6 6.9-3.1-6.9-3.2 3.5-6 6.2 4.4-.7-7.5h6.8l-.7 7.5 6.3-4.3 3.4 6-6.8 3 6.8 3.2-3.4 6-6.3-4.4.7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "m260.5 806.6 48.6 28.3 61.3-57.9 5.5 5.9-65.6 61.9-47.7-27.8-71 94.2-134.5-39.3-67.9 41.2-4.1-6.9 70.9-43 1.7.5L188.5 902z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBg);
export default __webpack_public_path__ + "static/media/line-bg.b1ce586ae61ce3607ebc923be8549dbf.svg";
export { ForwardRef as ReactComponent };